import {
  RSAA
} from 'redux-api-middleware';

import {
  State
} from '../assets/model.js';

export const RATING_SET_ANSWER = 'property-rating/rate/set-answer';
export const RATING_SET_ANSWER_STAY_QUESTION =
  'property-rating/rate/set-answer-stay-question';
export const NEXT_QUESTION = 'property-rating/rate/next-question';
export const SKIP_QUESTION = 'property-rating/rate/skip-question';
export const SEND_RATING = 'property-rating/rate/send-rating';

export const SENDING = 'property-rating/rate/sending';
export const SENDING_SUCCESS = 'property-rating/rate/sending-success';
export const SENDING_FAIL = 'property-rating/rate/sending-fail';

const initalState = State;

export default function reducer(state = initalState, action) {
  let path = '';
  let answer;
  let nextQuestion = '';

  switch (action.type) {
    case RATING_SET_ANSWER:
      path = action.payload.path;
      answer = action.payload.payload.answer;

      nextQuestion = action.payload.payload.nextQuestion;
      return {
        ...state,
        progress: state.progress + 6,
        currentQuestion: nextQuestion,
        Model: {
          ...state.Model,
          [path]: answer
        }
      };

    case RATING_SET_ANSWER_STAY_QUESTION:
      path = action.payload.path;
      answer = action.payload.payload.answer;

      return {
        ...state,
        Model: {
          ...state.Model,
          [path]: answer
        }
      };

    case NEXT_QUESTION:
      nextQuestion = action.payload;
      return {
        ...state,
        currentQuestion: nextQuestion,
        progress: state.progress + 8.3
      };
    case SKIP_QUESTION:
      return {
        ...state
      };
    case SENDING:
      return {
        ...state
      };
    case SENDING_SUCCESS:
      return {
        ...state
      };
    case SENDING_FAIL:
      return {
        ...state
      };
    default:
      return state;
  }
}

export function setAnswer(answer) {
  return {
    type: RATING_SET_ANSWER,
    payload: answer
  };
}

export function setAnswerStayQuestion(answer) {
  return {
    type: RATING_SET_ANSWER_STAY_QUESTION,
    payload: answer
  };
}

export function nextQuestion(answer) {
  return {
    type: NEXT_QUESTION,
    payload: answer
  };
}

export function skipQuestion(answer) {
  return {
    type: SKIP_QUESTION,
    payload: answer
  };
}

export function sendRating(model) {
  return {
    [RSAA]: {
      endpoint: 'http://www.api.immobilien-knowhow.de/propertyrating/12',
      types: [
        SENDING,
        {
          type: SENDING_SUCCESS,
          payload: model
        },
        SENDING_FAIL
      ],
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: model
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/rating.js